<template>
    <div>
        earth
        {{totalPrice()}}
    </div>
</template>
<script>
    export default {
        data() {
            return {
                sss:'--'
            }
        },
        methods:{
            totalPrice() {
                console.log(this.$store.state.order)
                return this.$store.state.order
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/details/earth.vue